import { useMemo, type ReactNode } from 'react'

import { createApiClient } from '@/lib/api'
import type { ConsoleConfig } from '@/lib/env/config'

import { ConsoleContext, type ConsoleContextValue } from './consoleContextValue'

export function ConsoleProvider({
  config,
  children,
}: {
  config: ConsoleConfig
  children: ReactNode
}) {
  const value = useMemo<ConsoleContextValue>(
    () => ({
      config,
      api: createApiClient(config),
      mutationsAllowed: config.cellRole === 'primary',
    }),
    [config],
  )
  return <ConsoleContext.Provider value={value}>{children}</ConsoleContext.Provider>
}
